document.addEventListener('DOMContentLoaded', function () {
  // ロゴのフェードインを実行
  const logo = document.querySelector('.opening .logo');
  logo.classList.add('fade-in');

  // ページのロードが完了したとき
  window.onload = function () {

    setTimeout(function () {
      const opening = document.querySelector('.opening');
      opening.classList.add('fade-out');
    }, 2000);
  };
});
